import React, { useState } from "react";
import userImg2 from "../../../../assets/images/users/48/avatar-2.jpg";
import { Button, Card, ListGroup } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import ChatModal from "Common/ChatModal";
import { jwtDecode } from "jwt-decode";
import { dummyProfileImage } from "Common/commaon";

interface userDetails {
  data: any;
}
interface JwtPayload {
  userType: string;
}

const InstructorDetails: React.FC<userDetails> = ({ data }) => {
  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode<JwtPayload>(token);
  } else {
    // console.error("Token is null");
  }
  const [chat, setChat] = useState<any>(false);
  const handleCloseChat = () => setChat(false);
const userName  = decoded.userType === "homeowner" ?data.contractor_first_name:data.user_first_name
const userType  = decoded.userType === "homeowner" ?"Contractor":"Homeowner"
const userID = decoded.userType === "homeowner"?data.lead_contractor:  data.lead_user_id
return (
    <React.Fragment>
      <Card>
        <Card.Header>
          {/* <Link to="/pages-user-overview" state={{ data }} className="float-end link-effect">View More <i className="bi bi-arrow-right align-baseline ms-1"></i></Link> */}
          <h6 className="card-title mb-0">
            {decoded.userType === "contractor"
              ? "Owner Details"
              : "Contractor Details"}
          </h6>
        </Card.Header>
        <Card.Body>
          <div className="d-flex gap-2 align-items-center mb-3">
            <div className="flex-shrink-0">
              <img
                src={dummyProfileImage}
                alt=""
                className="avatar-sm rounded"
              />
            </div>
            <div className="flex-grow-1">
              {decoded.userType === "contractor" ? (
                <>
                  <h6 className="fs-md">
                    {data && data.user_first_name} {data && data.user_last_name}
                  </h6>
                  <p className="text-muted mb-0">Home Owner</p>
                </>
              ) : (
                ""
              )}

              {decoded.userType === "homeowner" ? (
                <>
                  <h6 className="fs-md">
                    {data && data.contractor_first_name}{" "}
                    {data && data.contractor_last_name}
                  </h6>
                  <p className="text-muted mb-0">Contractor</p>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          {decoded.userType === "contractor" ? (
            <ListGroup className="list-group-fill-success">
              <ListGroup.Item
                as="a"
                href="#"
                className="list-group-item-action active"
              >
                <i className="ri-phone-line align-middle me-2"></i>
                {data && data.user_phone}
              </ListGroup.Item>
              <ListGroup.Item
                as="a"
                href="#"
                className="list-group-item-action"
              >
                <i className="ri-mail-line align-middle me-2"></i>
                {data && data.user_email}
              </ListGroup.Item>
            </ListGroup>
          ) : (
            ""
          )}
          {decoded.userType === "homeowner" ? (
            <ListGroup className="list-group-fill-success">
              <ListGroup.Item
                as="a"
                href="#"
                className="list-group-item-action active"
              >
                <i className="ri-phone-line align-middle me-2"></i>
                {data && data.contractor_phone}
              </ListGroup.Item>
              <ListGroup.Item
                as="a"
                href="#"
                className="list-group-item-action"
              >
                <i className="ri-mail-line align-middle me-2"></i>
                {data && data.contractor_email}
              </ListGroup.Item>
            </ListGroup>
          ) : (
            ""
          )}
          <div className="tailwind-prefix">
<button onClick={()=>{
  setChat(true)
  // navigate(`/chat-room?id=${data.lead_user_id}&name=${userName}&type=${userType}`)
}} className="bg-[#181A1F] text-white  w-full  text-center py-2 rounded-sm mt-3 ">
  Message
</button>
          </div>
          {/* <Button variant="subtle-info" className="w-100" id="agent-chat" onClick={handleShowChat}><i className="bi bi-chat-text align-baseline me-1"></i> Get In Touch</Button> */}
        </Card.Body>
      </Card>
      <ChatModal project={data} userName={userName}  userType={userType} OtherId={userID} show={chat} handleClose={handleCloseChat} />
    </React.Fragment>
  );
};

export default InstructorDetails;
